import { render, staticRenderFns } from "./ExpandedScopeGeneral.vue?vue&type=template&id=96cd575e&scoped=true&lang=pug&"
import script from "./ExpandedScopeGeneral.vue?vue&type=script&lang=js&"
export * from "./ExpandedScopeGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedScopeGeneral.vue?vue&type=style&index=0&id=96cd575e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cd575e",
  null
  
)

export default component.exports